import { memo, useCallback } from "react";
import { Box, styled } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import HeaderColumnProject from "./HeaderColumnProject";
import UnitRow from "./UnitRow";
import BuildingHeader from "./BuildingHeader";
import ToggleButton from "./ToggleButton";
import { IBuildingFromDetail } from "@rf/property/module/adapters/detail/prepareDetailPropertyBuildings";

interface BuildingItemProps {
  building: IBuildingFromDetail;
  buildingIndex: number;
  isExpanded: boolean;
  projectTypeId: number;
  visibleColumns: any;
  onToggle: (buildingId: number) => void;
  onCopyId: (id: number) => void;
}

const BuildingItem = memo(
  ({
    building,
    buildingIndex,
    isExpanded,
    projectTypeId,
    visibleColumns,
    onToggle,
    onCopyId
  }: BuildingItemProps) => {
    const handleToggle = useCallback(() => {
      onToggle(building.id);
    }, [building.id, onToggle]);

    const unitsToShow = isExpanded ? building.unit : building.unit.slice(0, 1);
    const hasMultipleUnits = building.unit && building.unit.length > 1;

    return (
      <WrapperContent>
        <BuildingContent>
          <BuildingHeader
            nameBuilding={building.nameBuilding}
            deliveryDate={building.deliveryDate}
            buildingIndex={buildingIndex}
          />

          <>
            <HeaderColumnProject
              realestateId={projectTypeId}
              show={visibleColumns}
            />
            {building.unit && building.unit.length > 0 ? (
              <>
                {unitsToShow.map((unit, unitIndex) => (
                  <UnitRow
                    key={unit.id || unitIndex}
                    unit={unit}
                    visibleColumns={visibleColumns}
                    realestateId={projectTypeId}
                    onCopyId={onCopyId}
                  />
                ))}
              </>
            ) : (
              <Box sx={{ p: 3, textAlign: "center" }}>
                <MxTypography variant="body2" color="text.secondary">
                  No hay unidades disponibles
                </MxTypography>
              </Box>
            )}
          </>
        </BuildingContent>

        {hasMultipleUnits && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
            <ToggleButton
              isExpanded={isExpanded}
              remainingUnits={building.unit.length - 1}
              onToggle={handleToggle}
            />
          </Box>
        )}
      </WrapperContent>
    );
  }
);

BuildingItem.displayName = "BuildingItem";

export default BuildingItem;

// Styled Components
const WrapperContent = styled(Box)(({ theme }) => ({
  marginTop: "20px",
  marginBottom: "20px",
  width: "98%",
  margin: "10px auto"
}));

const BuildingContent = styled(Box)(({ theme }) => ({
  border: "1px solid var(--m-color-blue-03)",
  borderBottom: "none",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  width: "100%",
  margin: "0 auto"
}));
